import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'un-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableComponent {
  @Input() loading?: boolean | null;
  @Input() total?: number | null;
  @Input() emptyDescription = $localize`No data found.`;
  @Input() icon = 'applications';
  @Input() btnText?: string;
  @Input() btnLink?: string;
}
